import React, {useEffect} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useParams} from 'react-router-dom';
import wrap from 'wraptile';

import handleUnmount from '@pluto/handle-unmount';
import BlueEvoContainer from './Providers/BlueEvo';
import MRSSContainer from './Providers/MRSS';
import {SetIngestData} from './IngestDataTypes';

const {parse} = JSON;

interface IngestDataContainerProviderProps {
    data: string | null;
    setIngestData: SetIngestData;
    resetIngestData: () => void;
    dataFormat: string;
    isEditable: boolean;
    putIngestData: (id: string, jsonData: {[key: string]: any}) => void;
}

export default function IngestDataContainerProvider(props: IngestDataContainerProviderProps) {
    const {
        data,
        setIngestData,
        putIngestData,
        resetIngestData,
        dataFormat,
        isEditable,
    } = props;
    const {id} = useParams<{id: string}>();

    const fetchIngestData = onEffect(setIngestData, id);

    useEffect(fetchIngestData, [id]);

    const onUnmount = handleUnmount(resetIngestData);

    useEffect(onUnmount, []);

    if (!data) {
        return <CircularProgress />;
    }

    if (dataFormat === 'bluevo_json') {
        return (
            <BlueEvoContainer
                id={id}
                putIngestData={putIngestData}
                isEditable={isEditable}
                data={parse(data)}
                data-testid="bluevo"
            />
        );
    }

    return <MRSSContainer data={data} />;
}

export const onEffect = wrap((setIngestData: SetIngestData, id: number) => {
    setIngestData(id);
});
